import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {AttributeWhitelist, IAttributeWhitelist} from 'app/blocks/model/attribute-whitelist.model';

@Injectable({
    providedIn: 'root'
})
export class AttributeWhitelistService extends EntityCrudService<IAttributeWhitelist> {
    constructor(http: HttpClient) {
        super(http, Resource.PRODUCT_ATTRIBUTE_WHITELIST, (obj?) => new AttributeWhitelist(obj));
    }
}
